import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useSalonPublicTheme } from '../../../context/SalonPublicThemeContext';


export default function ManualBookingNotice({
  bookingConfirmationMode,
  textAlign = { xs: 'left', md: 'right' },
}) {
  const { tokens: theme } = useSalonPublicTheme();
  const { t } = useTranslation();

  if (bookingConfirmationMode !== 'manual') {
    return null;
  }

  return (
    <Typography
      variant="caption"
      style={{ fontFamily: theme.typography.fontFamily.sans.join(', ') }}
      sx={{
        display: 'block',
        color: theme.colors.warning[700],
        fontFamily: theme.typography.fontFamily.sans.join(', '),
        fontSize: '0.75rem',
        lineHeight: 1.35,
        textAlign,
        maxWidth: { xs: '100%', md: 240 },
      }}
    >
      {t('appointment_workflow.service_confirmation.client_pending_notice')}
    </Typography>
  );
}
